<template>
  <div>功能1</div>
</template>
<script>
export default {
  name: 'Header',
  components: {
  },
  data(){
    return {
    }
  },
  created: function () {
  },
  computed: {
  },
  watch: {
  },
  mounted: function(){
    console.log('功能1 mounted')
  },
  destroyed: function(){
    console.log('功能1 destroyed')
  },
  methods: {
  },
}
</script>